import { CommonService } from './../../../../shared/services/common.service';
import { IKeyValuePair } from './../../../../_models/common/common';
import { VacantPostService } from './../../../../shared/services/vacant-post.service';
import { IPaged } from '../../../../_models/common/IPaged';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from 'src/app/shared/services/setting.service';
import { ISetting } from 'src/app/_models/cms/ISetting';

@Component({
  selector: 'app-vacant-post-list',
  templateUrl: './vacant-post-list.component.html'
})
export class VacantPostListComponent implements OnInit {
  private readonly PAGE_SIZE = 10;
  designations: IKeyValuePair[];
  financialYears: IKeyValuePair[];
  setting: ISetting;

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'UpdatedAt',
    sortDir: 'Descending',
    designationId: '',
    financialYearId: '',
  };

  columns = [
    { title: 'Sr.No.', key: 'Id', isSortable: true },
    { title: 'School', key: 'SchoolId', isSortable: true },
    { title: 'Designation', key: 'DesignationId', isSortable: true },
    { title: 'Type', key: 'VacancyTypeId', isSortable: true },
    { title: 'No Of Post', key: 'NoOfPost', isSortable: true },
    { title: 'Reason', key: 'NoOfPost', isSortable: true },
    { title: 'Certificate', key: 'NoOfPost', isSortable: true },
    {},
    // {}
  ];

  constructor(private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private service: VacantPostService,
    private settingService: SettingService,
    private commonService: CommonService,) {
  }

  ngOnInit() {
    this.settingService.getSetting().then(data => {
      this.setting = data;
      this.query.financialYearId = this.setting?.financialYearId;
    });
    this.bindDropDown();
    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort;
        this.query.sortDir = params.sortDir;
        this.query.designationId = params.designationId ? params.designationId : '';
        this.query.financialYearId = params.financialYearId ? params.financialYearId : '';
        this.populateVacantPosts();
      });
  }

  bindDropDown() {
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
    this.commonService.getFinancialYears().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.financialYears = response;
      }
    });
  }

  private populateVacantPosts() {
    this.service.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }

  filter() {
    this.query.page = 1;
    this.router.navigate(['/school/sanctioned-posts/vacant-posts'], {
      queryParams: this.query
    });
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortDir = (this.query.sortDir == "Descending" ? "Ascending" : "Descending");
    } else {
      this.query.sort = columnName;
      this.query.sortDir = "Descending";
    }

    this.router.navigate(['/school/sanctioned-posts/vacant-posts'], {
      queryParams: this.query
    });
  }

  export() {
    this.service.export(this.query).subscribe((data) => {
      const blob = new Blob([data], { type: 'application/octet-stream' });
      var downloadURL = window.URL.createObjectURL(data);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "vacant-post.xlsx";
      link.click();
    });
  }
  delete(id) {
    if (!confirm('Are you sure you want to delete this vacant post?')) return;
    this.service.delete(id).subscribe(() => {
      this.toastrService.success('vacant post deleted successful');
      this.ngOnInit()
    });
  }
}
